import { IconChevronLeft } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { StyledActionIcon } from "src/styled";
import { Button } from "../Button/Button";

export const BackButton = ({
  onClick,
  label,
}: {
  onClick?: () => void;
  label: string;
}) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1);
    }
  };

  return label && label.trim() !== "" ? (
    <Button
      variant="outline"
      onClick={handleGoBack}
      leftSection={<IconChevronLeft />}>
      {label}
    </Button>
  ) : (
    <StyledActionIcon data-cy="back-button" size="lg" onClick={handleGoBack}>
      <IconChevronLeft size="1.5rem" />
    </StyledActionIcon>
  );
};
